import React, { useContext } from 'react'
import bgImg from '../../../assets/imgs/logo.png';
import "./login.css"
import { useForm } from 'react-hook-form';
import axios from 'axios';
import jwt_decode from "jwt-decode";
import { useNavigate } from 'react-router-dom';
import { Context } from '../../../context/userContext';
import { baseUrl } from '../../../config/config';
import Swal from 'sweetalert2';

  const Login = () => {
    const navigate = useNavigate();
    const { setUserInfo, setToken, setUserRole } = useContext(Context); 
    const { register, handleSubmit } = useForm();

    // const onSubmit = async (data) => {
    //     axios.post(`${baseUrl}/auth/login`, {email: data.email, password: data.password})
    //     .then(res => {
    //         if(res){
    //             var decoded = jwt_decode(res.data.access_token);
    //             setToken(res.data.access_token);
    //             setUserInfo(decoded);
    //             sessionStorage.setItem('user', JSON.stringify(decoded));
    //             sessionStorage.setItem('token', res.data.access_token);
    //             navigate('/');
    //         }
    //     })
    //     .catch(err => {
    //         console.log(err);
    //         alert("Error "+err.response.data.statusCode+": "+err.response.data.message)
    //     })
    // }

    const onSubmit = async (data) => {
        try {
            const res = await axios.post(`${baseUrl}/auth/login`, { email: data.email, password: data.password });

            if (res) {
                var decoded = jwt_decode(res.data.access_token);
                setToken(res.data.access_token);
                setUserInfo(decoded);
                setUserRole(decoded.role); 
                sessionStorage.setItem('user', JSON.stringify(decoded));
                sessionStorage.setItem('token', res.data.access_token);

                // Vérification si l'utilisateur est un administrateur
                if (decoded.role === "admin") {
                    navigate('/');
                    Swal.fire({
                        icon: 'success',
                        title: 'Bienvenue dans le backoffice',
                        text: 'Vous êtes connecté en tant qu\'administrateur.',
                    });
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Droits d\'administration insuffisants',
                        text: 'Vous n\'avez pas les droits d\'administration.',
                    });
                }
            }
        } catch (err) {
            console.log(err);
            alert("Error " + err.response.data.statusCode + ": " + err.response.data.message);
        }
    }

  return (
    <section className='Auth'>
        <div className="register">
            <div className="register-container">
                <h2>Fidirana</h2>

                <form id='form' className='formulaire contenu' onSubmit={handleSubmit(onSubmit)}>
                    <input type="email" {...register("email")} placeholder='email' required/>
                    <input type="password" {...register("password")} placeholder='password' required/>
                    <button className='bouton'>Hiditra</button>
                </form>

            </div>
            <div className="picture">
                <img src={bgImg} alt="" />
            </div>
        </div>
    </section>
  )
}

export default Login